import {
  convertToHtml,
  convertToText,
  removeMarkdown,
} from "@smart/itops-serialisation-basic";

import { defaultTemplate, MessageTemplateOptions } from "./types";
import { appendFormLink } from "./utils";

export const message = ({
  template,
  client,
  category,
  matterType,
  team,
  link,
  form,
  submissionCreatedAt,
  shouldAppendFormLink = true,
  format,
}: MessageTemplateOptions) => {
  const templateToUse = template || defaultTemplate[category];
  const clientName =
    client?.person?.firstName ||
    client?.company?.name ||
    client?.trust?.name ||
    client?.contactName ||
    "";
  const clientCustomName = client?.person?.customName || clientName;
  const clientEmail = client?.person?.email || client?.company?.email || "";
  const firmName = team?.name || "our team";
  const firmPhone =
    typeof team?.phone === "string"
      ? team?.phone
      : `${team?.phone?.areaCode}${team?.phone?.number}`;

  const convertOptions = {
    template: shouldAppendFormLink
      ? appendFormLink(templateToUse)
      : templateToUse,
    data: {
      clientFirstName: client?.person?.firstName || "",
      clientLastName: client?.person?.lastName || "",
      clientName,
      clientCustomName,
      clientEmail,
      matterCategory: category,
      matterType: matterType.name,
      firmName,
      firmPhone: firmPhone || "",
      formLink: link,
      formCreatedAt: submissionCreatedAt || "",
      formTitle: form.title,
    },
  };

  const text =
    format === "communicate"
      ? // Make it consistent with the frontend send communicate message
        removeMarkdown(convertToText(convertOptions), ["links"])
      : convertToText(convertOptions);

  return {
    link,
    html: convertToHtml(convertOptions),
    text,
  };
};

export const getTemplate = (
  defaultClientMessage:
    | {
        matter?: string | null;
        lead?: string | null;
        reminder?: string | null;
      }
    | null
    | undefined,
  category: "matter" | "lead" | "reminder",
) => defaultClientMessage?.[category]?.trim() || undefined;
